import * as z from 'zod';

export const verifyAccountRequestFormSchema = z.object({
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
});

export type VerifyAccountRequestFormValues = z.infer<
  typeof verifyAccountRequestFormSchema
>;

export const resetPasswordRequestFormSchema = z.object({
  isRetry: z.boolean(),
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
});

export type ResetPasswordRequestFormValues = z.infer<
  typeof resetPasswordRequestFormSchema
>;

export const resetPasswordFormSchema = z.object({
  token: z.string(),
  organizationId: z.number(),
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
  password: z.string().min(1, {
    message: 'This field is required',
  }),
});

export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>;

export const inviteOrganizationCompleteFormSchema = z.object({
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
  token: z.string(),
  organizationId: z.number(),
  password: z.string().min(1, {
    message: 'This field is required',
  }),
});

export type InviteOrganizationFormValues = z.infer<
  typeof inviteOrganizationCompleteFormSchema
>;
